import React from 'react';
import PropTypes from 'prop-types';
import EditPDFLandingPageFullWidthUploadPanel from './EditPDFLandingPageFullWidthUploadPanel';

const EditPDFLandingPageFreeWriteBackgroundLayout = props => (
  <div
    className={`
      edit-pdf-container
      large-upload-panel-mock-freewrite-wrapper
      large-upload-panel-wrapper
    `}
  >
    <img
      src="/images/freewrite-toolbar.png"
      alt="Mock Free Write Background"
      className="large-upload-panel-mock-freewrite-bg-img img-lg"
    />
    <img
      src="/images/freewrite-toolbar-xs.png"
      alt="Mock Free Write Background"
      className="large-upload-panel-mock-freewrite-bg-img img-xs"
    />
    <EditPDFLandingPageFullWidthUploadPanel
      ctaId={props.ctaId}
      headerCopy="PDF Editor"
      subHeader="Upload any PDF, Word Document, or Image to get started."
    />
  </div>
);

EditPDFLandingPageFreeWriteBackgroundLayout.propTypes = {
  ctaId: PropTypes.string.isRequired,
};

export default EditPDFLandingPageFreeWriteBackgroundLayout;



// WEBPACK FOOTER //
// ./src-react/EditPDFLandingPage/EditPDFLandingPageFreeWriteBackgroundLayout.jsx